import clsx from 'clsx'

import { Badge } from '@wartek-id/badge'
import { Text } from '@wartek-id/text'

import { formatNumber } from '@/utils/string'

const MAP_COLUMN_WIDTH = {
  number: 'min-w-[40px]',
  objectClass: 'min-w-[150px]',
  objectSubClass: 'min-w-[150px]',
  variable: 'min-w-[250px]',
  alias: 'min-w-[200px]',
  definition: 'min-w-[300px]',
  selectionReference: 'min-w-[200px]',
  timeReference: 'min-w-[150px]',
  inputClassification: 'min-w-[200px]',
  validationRules: 'min-w-[350px]',
  question: 'min-w-[250px]',
  isPublic: 'min-w-[170px]',
  publicText: 'min-w-[170px]',
  // Standard Data
  concept: 'min-w-[200px]',
  classification: 'min-w-[250px]',
  // child columns classification - 1
  penyajian: 'min-w-[250px]',
  // child columns classification - 2
  isian: 'min-w-[250px]',
  unit: 'min-w-[150px]',
  values: 'min-w-[150px]',
}

export const CustomMetadataCellRenderer = ({ row, col }) => {
  const value = row.getValue()

  if (Array.isArray(value)) {
    return (
      <div data-type="array" className="text-left">
        <ol className="list-decimal space-y-1 pl-8">
          {(value || [])?.map((item, index) => {
            const matchSup = item.match(/<sup>(.*?)<\/sup>/)
            const withoutSup = item.replace(/<sup>(.*?)<\/sup>/, '')
            const character = matchSup ? matchSup[1] : ''

            return (
              <li key={item} className="pl-2">
                <Text
                  data-type={`item-${index}`}
                  className={clsx(MAP_COLUMN_WIDTH[col?.id])}
                >
                  {withoutSup}{' '}
                  {matchSup ? (
                    <sup className="-top-[0.2em] !text-base text-blue-60">
                      {character}
                    </sup>
                  ) : (
                    ``
                  )}
                </Text>
              </li>
            )
          })}
        </ol>
      </div>
    )
  }

  if (typeof value === 'boolean') {
    return (
      <div
        data-type="boolean"
        className={clsx('text-center', MAP_COLUMN_WIDTH[col?.id])}
      >
        <Badge variant={value ? 'success' : 'critical'}>
          {value ? 'Ya' : 'Tidak'}
        </Badge>
      </div>
    )
  }

  if (typeof value === 'number') {
    return (
      <div
        data-type="number"
        className={clsx('text-right', MAP_COLUMN_WIDTH[col?.id])}
      >
        <Text>{formatNumber(value)}</Text>
      </div>
    )
  }

  return (
    <div data-type={col?.id || ''} className={clsx(MAP_COLUMN_WIDTH[col?.id])}>
      <Text>{value}</Text>
    </div>
  )
}
